"use client";

import { type FC, useEffect, useState } from "react";
import { motion } from "motion/react";

import { waveBarStyle, waveContainerStyle } from "./RecordingWave.css";

export type RecordingWaveProps = {
  volume: number;
  height?: number;
  parts?: number;
};

export const RecordingWave: FC<RecordingWaveProps> = ({
  volume,
  height = 48,
  parts = 40,
}) => {
  const [volumes, setVolumes] = useState<number[]>(Array(parts).fill(0));

  useEffect(() => {
    const normalizedVolume = Math.min(height, volume / 2);

    setVolumes((prevVolumes) => {
      const newVolumes = [...prevVolumes];

      newVolumes.push(normalizedVolume);
      if (newVolumes.length > 20) {
        newVolumes.shift();
      }

      return newVolumes;
    });
  }, [volume, height]);

  return (
    <div className={waveContainerStyle} style={{ height }}>
      {volumes.map((volume, index) => (
        <motion.div
          key={index}
          className={waveBarStyle}
          style={{ height: volume }}
        />
      ))}
    </div>
  );
};
